import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monUserDate',
    standalone: true,
})
export class UserDatePipe implements PipeTransform {
    private readonly monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ];

    private readonly dayNames = [
        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
    ];

    transform (date: string, format?: string): string {
        format = format ?? 'll';
        if (!date) {
            return '';
        }

        return this.formatDate(new Date(date), this.customFormats(format));
    }

    private customFormats (format: string): string {
        switch (format) {
            case 'fullDate':
                return 'dddd, MMMM D, YYYY';
            case 'll':
                return 'MMM D, YYYY';
            default:
                return format;
        }
    }

    private formatDate (date: Date, format: string): string {
        if (!format || !date || isNaN(date.getTime())) {
            return '';
        }

        return format
            .replace('dddd', this.dayNames[date.getDay()])
            .replace('MMMM', this.monthNames[date.getMonth()])
            .replace('MMM', this.monthNames[date.getMonth()].slice(0, 3))
            .replace('D', date.getDate().toString())
            .replace('YYYY', date.getFullYear().toString());
    }
}
